module.exports = __webpack_public_path__ + "img/scatteredclouds.66cc3aa7.png";